const createSearchState = () => ({
  data: [],
  loading: false,
  error: null,
});

const initialState = {
  isOpen: false,
  mode: 'file',
  requestMode: false,
  locationLabel: '',
  locationTrail: [],
  saveStatus: 'idle',
  originEntity: null,
  linkedContacts: [],
  linkedProperties: [],
  linkedDevelopments: [],
  properties: createSearchState(),
  developments: createSearchState(),
  contacts: createSearchState(),
};

export default initialState;
